/*
 * Glass shimmer button, ported from RareUI (https://www.rareui.com), MIT License,
 * Copyright (c) 2025 Swapnil Kalambe. See THIRD_PARTY_NOTICES.md.
 * Rendered as a Link or button; keyframes live in index.css (kj-glass-shimmer).
 */
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export default function GlassShimmerButton({ to, children, className = "", ...props }) {
  const cls = cn(
    "group relative isolate inline-flex items-center justify-center overflow-hidden rounded-control",
    "h-12 px-6 gap-2 font-body text-base font-semibold text-white",
    "bg-brand-gold hover:bg-brand-gold-deep transition-colors duration-sm",
    className
  );
  const inner = (
    <>
      <span aria-hidden="true" className="kj-glass-shimmer pointer-events-none absolute inset-0 -z-10" />
      <span aria-hidden="true" className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/50 to-transparent" />
      <span className="relative z-10 inline-flex items-center gap-2 tracking-wide">{children}</span>
    </>
  );
  return to ? <Link to={to} className={cls} {...props}>{inner}</Link> : <button className={cls} {...props}>{inner}</button>;
}
